import React from 'react';

function SunneyOverview() {
    return(
        <section className="sunney-overview">
            <h2>Overview:</h2>
            <p>The constant pursuit of internships, job applications, and academic excellence can leave students little room to relax, leading to a pervasive sense of burnout that permeates their years on campus. 
                <mark className="highlight">&nbsp;As an university student myself, I’ve dealt with burnout, stress, and depression preparing for the real world when college should be a time to explore your interests and discover new experiences.&nbsp;</mark>
                So, how can students explore while still keep up with their studies?

            </p>
        </section>

    );
}

export default SunneyOverview;

